module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('ol', {
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/01_Cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/03_Titlepage"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/04_Copyright"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/05_Contents"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/06_Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/07_List_of_Illustrations"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/08_Dramatis_Personae"
    }
  }, [_vm._v("Dramatis Personae")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/09_Prologue"
    }
  }, [_vm._v("Prologue: 16 March 1917")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/10_Introduction"
    }
  }, [_vm._v("Introduction: The Navy at War")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/11_Part01"
    }
  }, [_vm._v("Part One: The German auxiliary Cruiser Guerre de Course")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/12_Chapter01"
    }
  }, [_vm._v("Chapter 1: A Change of Strategy, 1914")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/13_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Cruiser Warfare")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/14_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Escapee, 1914")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/15_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Dancing Elephants, 1914")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Weary Traveller, 1914–1915")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/17_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Enter the U-boat, 1914–1916")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/18_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Seagull, 1915–1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/19_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Blockade")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/20_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Northern Patrol, 1914")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Enter the Merchantmen, 1914–1915")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Volunteers")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Captains Courageous")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: On Patrol, 1915–1916")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/26_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Long Duty Ends, 1916–1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/27_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Blockade and Trade")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/28_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: A Desperate Battle")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/29_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Yarrowdale and Prisoners, 1916–1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/30_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Of Ships and Men, 1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/31_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: First Contact, March 1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/32_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Battle, March 1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/33_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: Endings")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/34_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Secrets and Rewards")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/35_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Postscript")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/36_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Coda")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/37_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/37_Appendix01#Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Moewe’s Victims")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/38_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Armed Merchant Cruisers of the 10th Cruiser Squadron")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/39_Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3: Example of a T.124 Form")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/40_Appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 4: Principles of Merchant Ship Construction")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/41_Appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 5: Andersons in the Shetlands, HMS Dundee")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/42_Select_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks"
    }
  }, [_c('h2', [_vm._v("Guide")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "cover",
      "href": "#/xhtml/01_Cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "title",
      "href": "#/xhtml/03_Titlepage"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/04_Copyright"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/xhtml/05_Contents"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "dedication",
      "href": "#/xhtml/06_Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/07_List_of_Illustrations"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/08_Dramatis_Personae"
    }
  }, [_vm._v("Dramatis Personae")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/09_Prologue"
    }
  }, [_vm._v("Prologue: 16 March 1917")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/10_Introduction"
    }
  }, [_vm._v("Introduction: The Navy at War")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/11_Part01"
    }
  }, [_vm._v("Part One: The German auxiliary Cruiser Guerre de Course")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/12_Chapter01"
    }
  }, [_vm._v("Chapter 1: A Change of Strategy, 1914")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/13_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Cruiser Warfare")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/14_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Escapee, 1914")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/15_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Dancing Elephants, 1914")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Weary Traveller, 1914–1915")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/17_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Enter the U-boat, 1914–1916")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/18_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Seagull, 1915–1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/19_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Blockade")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/20_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Northern Patrol, 1914")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Enter the Merchantmen, 1914–1915")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Volunteers")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Captains Courageous")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: On Patrol, 1915–1916")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/26_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Long Duty Ends, 1916–1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/27_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Blockade and Trade")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/28_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: A Desperate Battle")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/29_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Yarrowdale and Prisoners, 1916–1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/30_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Of Ships and Men, 1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/31_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: First Contact, March 1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/32_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Battle, March 1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/33_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: Endings")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/34_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Secrets and Rewards")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/35_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Postscript")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/36_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Coda")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/37_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/37_Appendix01#Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Moewe’s Victims")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/38_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Armed Merchant Cruisers of the 10th Cruiser Squadron")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/39_Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3: Example of a T.124 Form")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/40_Appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 4: Principles of Merchant Ship Construction")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/41_Appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 5: Andersons in the Shetlands, HMS Dundee")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/42_Select_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "page-list"
    }
  }, [_c('h2', [_vm._v("Pagebreaks of the print version")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Frontmatter#page1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Frontmatter#page2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Titlepage#page3"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Copyright#page4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Contents#page5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Dedication#page6"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Dramatis_Personae#page7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Dramatis_Personae#page8"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Prologue#page9"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Prologue#page10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#page11"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#page12"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#page13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#page14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Part01#page15"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Part01#page16"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01#page17"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01#page18"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01#page19"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01#page20"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01#page21"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01#page22"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01#page23"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#page24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#page25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#page26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#page27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#page28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#page29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#page30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#page31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#page32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#page33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#page34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#page35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#page36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#page37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04#page38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04#page39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04#page40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04#page41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04#page42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04#page43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05#page44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05#page45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05#page46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05#page47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05#page48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05#page49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06#page50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06#page51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06#page52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06#page53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06#page54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06#page55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#page66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Part02#page67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Part02#page68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#page69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#page70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#page71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#page72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#page73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#page74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#page75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#page76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09#page77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09#page78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09#page79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09#page80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09#page81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09#page82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#page83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#page84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#page85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#page86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#page87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#page88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#page89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#page90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#page91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#page92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#page93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#page94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#page95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#page96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#page97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#page112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#pagePLI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLI")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#pagePLII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#pagePLIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLIII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#pagePLIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLIV")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#pagePLV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLV")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#pagePLVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLVI")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#pagePLVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLVII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#pagePLVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLVIII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter13#page113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter13#page114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter13#page115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter13#page116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#page136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Part03#page137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Part03#page138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter15#page139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter15#page140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter15#page141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter15#page142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter15#page143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter16#page144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter16#page145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter16#page146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter16#page147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter16#page148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter16#page149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter16#page150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter17#page151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter17#page152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter17#page153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter17#page154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18#page164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Part04#page165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Part04#page166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter19#page167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter19#page168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter19#page169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter19#page170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter19#page171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20#page189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter21#page190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter21#page191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter21#page192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Appendix01#page193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Appendix01#page194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix02#page195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix02#page196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Appendix03#page197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Appendix03#page198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Appendix04#page199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Appendix05#page200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Select_Bibliography#page201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Select_Bibliography#page202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Select_Bibliography#page203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Select_Bibliography#page204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 54
// module chunks = 0